const Mutations = Object.freeze({
	SET_FORM_FIELDS:
		'inventoryFormModule/formBuilder/formFields/SET_FORM_FIELDS',
	SET_SELECTED_FORM_FIELD:
		'inventoryFormModule/formBuilder/formFields/SET_SELECTED_FORM_FIELD',
	SET_GRIDVIEW_FIELDS:
		'inventoryFormModule/formBuilder/formFields/SET_GRIDVIEW_FIELDS',
	SET_LOADING: 'inventoryFormModule/formBuilder/formFields/SET_LOADING',
	SET_INTERACTIONS:
		'inventoryFormModule/formBuilder/formFields/SET_INTERACTIONS',

	ADD_FIELD: 'inventoryFormModule/formBuilder/formFields/ADD_FIELD',
	UPDATE_FIELD: 'inventoryFormModule/formBuilder/formFields/UPDATE_FIELD',
	DELETE_FIELD: 'inventoryFormModule/formBuilder/formFields/DELETE_FIELD',
});

export const Actions = Object.freeze({
	LOAD: 'inventoryFormModule/formBuilder/formFields/LOAD',
	LOAD_GRIDVIEW_FIELDS:
		'inventoryFormModule/formBuilder/formFields/LOAD_GRIDVIEW_FIELDS',
	LOAD_INTERACTIONS:
		'inventoryFormModule/formBuilder/formFields/LOAD_INTERACTIONS',
	SET_SELECTED_FORM_FIELD:
		'inventoryFormModule/formBuilder/formFields/SET_SELECTED_FORM_FIELD',
	ADD: 'inventoryFormModule/formBuilder/formFields/ADD',
	UPDATE: 'inventoryFormModule/formBuilder/formFields/UPDATE',
	REORDER_FIELDS: 'inventoryFormModule/formBuilder/formFields/REORDER_FIELDS',
	DELETE: 'inventoryFormModule/formBuilder/formFields/DELETE',
	CLEAR: 'inventoryFormModule/formBuilder/formFields/CLEAR',
});

export const Getters = Object.freeze({
	SELECTED_FIELD_INTERACTIONS:
		'inventoryFormModule/formBuilder/formFields/INTERACTIONS_FOR_SELECTED_FIELD',
	FORM_FIELDS: 'inventoryFormModule/formBuilder/formFields/FORM_FIELDS',
	AVAILABLE_GRIDVIEW_FIELDS:
		'inventoryFormModule/formBuilder/formFields/AVAILABLE_GRIDVIEW_FIELDS',
	SELECTED_FIELD: 'inventoryFormModule/formBuilder/formFields/SELCTED_FIELD',
	GRID_LOADING: 'inventoryFormModule/formBuilder/formFields/GRID_LOADING',
});

import { GeneralActions, InventoryFormActions } from '../../../../../actions';
import dataService from '../../../../../../services/data/inventoryFormService';
export default {
	state: {
		formFields: [],
		gridViewFields: [],
		interactions: [],
		selectedFormField: null,
		loading: false,
	},
	mutations: {
		[Mutations.SET_LOADING](state, value) {
			state.loading = value;
		},
		[Mutations.SET_FORM_FIELDS](state, items) {
			state.formFields = items;
		},
		[Mutations.SET_INTERACTIONS](state, items) {
			state.interactions = items;
		},
		[Mutations.SET_GRIDVIEW_FIELDS](state, items) {
			state.gridViewFields = items;
		},

		[Mutations.SET_SELECTED_FORM_FIELD](state, item) {
			state.selectedFormField = item;
		},

		[Mutations.ADD_FIELD](state, field) {
			state.formFields.push(field);
		},

		[Mutations.UPDATE_FIELD](state, field) {
			let index = state.formFields.findIndex(
				(searchField) => searchField.Id === field.Id
			);
			if (index < 0) return;
			state.formFields.splice(index, 1, field);
		},

		[Mutations.DELETE_FIELD](state, field) {
			let item = state.formFields.find((x) => x.Id == field.Id);
			var index = state.formFields.indexOf(item);
			if (index < 0) return;
			state.formFields.splice(index, 1);
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_SELECTED_FORM_FIELD, null);
				commit(Mutations.SET_FORM_FIELDS, []);
				commit(Mutations.SET_LOADING, false);
				resolve();
			});
		},
		[Actions.LOAD]({ commit, dispatch }, inventoryFormId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getFormFields(inventoryFormId)
					.then((resp) => {
						commit(Mutations.SET_FORM_FIELDS, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.REORDER_FIELDS]({ dispatch }, { id, data }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				// dataService.reorderFormField(id, data.filter(column => column.HiddenBehaviour === 0)
				dataService
					.reorderFormField(
						id,
						data
							.sort((a, b) => a.Order - b.Order)
							.map((x) => ({ Id: x.Id, Order: x.Order }))
					)
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.LOAD_GRIDVIEW_FIELDS]({ commit, dispatch }, inventoryFormId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getGridViewFields(inventoryFormId)
					.then((resp) => {
						commit(Mutations.SET_GRIDVIEW_FIELDS, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD_INTERACTIONS]({ commit, dispatch }, inventoryFormId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getInteractionByInventotyFormId(inventoryFormId)
					.then((resp) => {
						commit(Mutations.SET_INTERACTIONS, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.SET_SELECTED_FORM_FIELD]({ commit }, item) {
			commit(Mutations.SET_SELECTED_FORM_FIELD, item);
		},

		[Actions.ADD]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.insertFormField(item)
					.then((resp) => {
						commit(Mutations.ADD_FIELD, resp.data);
						return dispatch(Actions.LOAD, item.InventoryFormId);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(InventoryFormActions.RELOAD);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},

		[Actions.UPDATE]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateFormField(item)
					.then(() => {
						commit(Mutations.UPDATE_FIELD, item);
						dispatch(InventoryFormActions.RELOAD);
						dispatch(GeneralActions.LOADING, false);
						return dispatch(Actions.LOAD, item.InventoryFormId);
					})
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},

		[Actions.DELETE]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteFormField(item)
					.then(() => {
						commit(Mutations.DELETE_FIELD, item);
						dispatch(InventoryFormActions.RELOAD);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
	},
	getters: {
		[Getters.GRID_LOADING]: (state) => {
			return state.loading;
		},
		[Getters.SELECTED_FIELD_INTERACTIONS]: (state) => {
			let actions = [];
			let conditions = [];
			if (state.interactions.length == 0)
				return { Actions: actions, Conditions: conditions };
			if (!state.selectedFormField)
				return { Actions: actions, Conditions: conditions };
			state.interactions.forEach((i) => {
				if (i.Actions.length > 0) {
					i.Actions.forEach((a) => {
						if (a.FormFieldId == state.selectedFormField.Id) {
							actions.push(a);
						}
					});
				}
				if (i.Conditions.length > 0) {
					if (i.Conditions.length > 0) {
						i.Conditions.forEach((a) => {
							if (a.FormFieldId == state.selectedFormField.Id) {
								conditions.push(a);
							}
						});
					}
				}
			});
			return { Actions: actions, Conditions: conditions };
		},

		[Getters.FORM_FIELDS]: (state) => {
			if (!state.formFields) return [];
			if (state.formFields.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.formFields));
		},
		[Getters.SELECTED_FIELD]: (state) => {
			if (!state.selectedFormField) return null;
			return JSON.parse(JSON.stringify(state.selectedFormField));
		},

		[Getters.AVAILABLE_GRIDVIEW_FIELDS]: (state) => {
			if (!state.gridViewFields) return [];
			if (!state.gridViewFields.length < 0) return [];

			let existing = [];
			if (state.formFields && state.formFields.length > 0) {
				state.formFields.forEach((f) => {
					if (f.GridViewFieldIds && f.GridViewFieldIds.length > 0) {
						existing = existing.concat(f.GridViewFieldIds);
					}
				});
			}

			if (
				state.selectedFormField &&
				state.selectedFormField.GridViewFieldIds &&
				state.selectedFormField.GridViewFieldIds.length > 0
			) {
				state.selectedFormField.GridViewFieldIds.forEach((id) => {
					let index = existing.indexOf(id);
					if (index >= 0) existing.splice(index, 1);
				});
			}

			let items = [];
			state.gridViewFields.forEach((gvf) => {
				if (existing.indexOf(gvf.Id) < 0) {
					items.push(gvf);
				}
			});
			return JSON.parse(JSON.stringify(items));
		},
	},
};
